import { ref } from 'vue'

/**
 * Used template
 * @type {null|string}
 */
const currentTheme = ref(null)

/**
 * Change theme logic
 *
 * @param selector
 * @param attribute
 * @param localStorageKey
 * @returns {{getTheme: (function(): *), setTheme: (function(string): void), theme: *, init: (function(): Promise<void>)}}
 */
export function useThemes(
  selector = 'html',
  attribute = 'data-theme',
  localStorageKey = 'theme',
) {
  const availableStates = ['auto', 'dark', 'light']

  let getTheme = () => {
    let theme = window.localStorage.getItem(localStorageKey)

    if (availableStates.includes(theme)) {
      currentTheme.value = theme
    }

    return currentTheme.value
  }

  /**
   * Change current theme:
   *  auto - choose auto theme colors
   *  dark   - use dark mode force
   *  light  - user light mode force
   *
   * @param {string} value
   */
  let setTheme = (value) => {
    let body = document.querySelector(selector)

    currentTheme.value = value
    body.setAttribute(attribute, value)
    window.localStorage.setItem(localStorageKey, currentTheme.value)
  }

  let init = async () => {
    let theme = getTheme()
    setTheme(availableStates.includes(theme) ? theme : 'auto')
  }

  return {
    theme: currentTheme,
    setTheme,
    getTheme,
    init,
  }
}
